import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { InspectionPointService } from '../../shared/services/index';
import { InspectionPoint } from '../../shared/models/index';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'section-points',
    templateUrl: './list.component.html',
    standalone: false
})
export class PointListPageComponent implements OnInit {
  @Input() sectionId: string;
  @Input() inspectionId: string;
  points: InspectionPoint[];
  @Output() public toggleGetPoints: EventEmitter<any> = new EventEmitter();
  public loading: Boolean = true;

  constructor(public pointService: InspectionPointService, private router: Router) {}

  ngOnInit(): void {
    this.initData();
  }

  initData(): void {
    this.pointService.getPoints(this.inspectionId, this.sectionId).subscribe((data) => {
      this.points = data;
      this.loading = false;
      this.toggleGetPoints.emit(this.points);
    });
  }

  public openPoint(point: InspectionPoint): void {
    this.pointService.setPoint(point);
    this.router.navigate([environment.applicationRoute, 'inspections', this.inspectionId, 'points', point.id]);
  }

  public selectPoint(point: any) {
    point.selected = !point.selected;
  }
}
